// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TGetOffersByPinRequest,
  TGetOffersByPinModel,
  IMappers,
  TGetOffersByPinResponse_,
  TGetOffersByPinResponse,
  TGetOffersByPinResponse_1,
  TGetOffersByPinResponseError,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';

export function createGetOffersByPinModel(parameters: TGetOffersByPinRequest): TGetOffersByPinModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'search-offers',
    pathApi: '/v1/get-offers-by-pin/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IGetOffersByPinOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TGetOffersByPinRequest;
}

export async function fetchGetOffersByPin<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetOffersByPinOptions<TResponse200, TResponse400>): Promise<TGetOffersByPinResponse | TResponse200 | TResponse400> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetOffersByPinModel(parameters),
    config,
  )) as FetchResponse<TGetOffersByPinResponse_>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TGetOffersByPinResponse_1, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as TGetOffersByPinResponseError, headers);
    }
  }
  return {
    statusCode,
    response,
    headers: Array.from(headers),
  } as TGetOffersByPinResponse;
}
